<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.notification')"
    ref="sourcePage"
    resource="notifications"
  >
    <template slot="action">
      <el-button
        type="primary"
        @click="handleMarkAllAsRead"
      >
        全部已读
      </el-button>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/notifications.js';
import { itemLabel } from '../custom_columns_extend.js';

@Component
export default class Notifications extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      {
        prop: 'title_eq',
        label: '标题',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemoteSearch: async (keyword) => {
              return await this.$request.get('/notifications/title_options', { keyword });
            },
            xRemotePreload: async () => {
              return await this.$request.get('/notifications/title_options');
            },
          }
        }
      },
      'is_read_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'title',
      {
        prop: 'target',
        label: '对象',
        minWidth: 100,
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.target_type === 'ProductDesign') {
            return <bean-link keepNode to={{ name: 'product_designs.show', params: { id: row.target_id } }}>{itemLabel(row.target)}</bean-link>
          } else if (row.target_type === 'Order') {
            return <bean-link keepNode to={{ name: 'orders.show', params: { id: row.target_id } }}>{itemLabel(row.target)}</bean-link>
          }
        },
      },
      {
        key: 'content',
        renderCell: (h, { props: { value } }) => {
          if (!value) {
            return '<span>/</span>'
          }
          return <span style="white-space: pre-wrap; word-break: break-all">{value}</span>
        },
        align: 'left',
        minWidth: 250,
      },
      'is_read',
      'created_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      !row.is_read && {
        component: 'confirmButton',
        props: {
          label: '已读',
          type: 'primary',
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/notifications/${row.id}/mark_as_read`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'notifications.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'notifications.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
   * 处理全部标记为已读
   */
  async handleMarkAllAsRead() {
    await this.$autoLoading(this.$request.put('/notifications/mark_all_as_read'));
    this.$message.success(this.$t('operateSuccess'));
    this.$refs.sourcePage.fetchData();
  }
}

export const route = [
  {
    path: '/notifications',
    name: 'notifications.index',
    component: Notifications,
    props: {
      type: 'index',
    }
  },
  {
    path: '/notifications/new',
    name: 'notifications.new',
    component: Notifications,
    props: {
      type: 'new',
    }
  },
  {
    path: '/notifications/:id',
    name: 'notifications.show',
    component: Notifications,
    props: {
      type: 'show',
    }
  },
  {
    path: '/notifications/:id/edit',
    name: 'notifications.edit',
    component: Notifications,
    props: {
      type: 'edit'
    }
  }
]
</script>
